import { z } from "zod/v4";
import { bookingResponseSchema } from "../../schemas/finance";
import { fetchApi, fetchVoid } from "../client/internal";

export const bookings = {
	list: (
		clubId: string,
		params?: {
			from?: string;
			to?: string;
			sphere?: string;
			account_id?: string;
			type?: string;
		},
	) => {
		const qs = new URLSearchParams();
		if (params?.from) qs.set("from", params.from);
		if (params?.to) qs.set("to", params.to);
		if (params?.sphere) qs.set("sphere", params.sphere);
		if (params?.account_id) qs.set("account_id", params.account_id);
		if (params?.type) qs.set("type", params.type);
		const q = qs.toString();
		return fetchApi(`/${clubId}/bookings${q ? `?${q}` : ""}`, z.array(bookingResponseSchema));
	},
	create: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/bookings`, bookingResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, bookingId: string, data: unknown) =>
		fetchApi(`/${clubId}/bookings/${bookingId}`, bookingResponseSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, bookingId: string) =>
		fetchVoid(`/${clubId}/bookings/${bookingId}`, { method: "DELETE" }),
};
